import { render, staticRenderFns } from "./Historias.vue?vue&type=template&id=8fd5e308"
import script from "./Historias.vue?vue&type=script&lang=js"
export * from "./Historias.vue?vue&type=script&lang=js"
import style0 from "./Historias.vue?vue&type=style&index=0&id=8fd5e308&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports